import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { poModeValues, poStatusValues, poSubtypeValues, poTypeValues, priorityValues, procurementCategoryValues } from '@/lib/api/orpc/contracts/po-ledger';
export const PoTableFilterSchema = z.object({
  ...dataGridSearchFields,
  freeText: z.string().optional(),
  // 基本フィルタ（ツールバー）。specs/po-ledger-list「一覧の検索・フィルタ」参照。
  statusIn: z.array(z.enum(poStatusValues)).optional(),
  deliveryDueDateFrom: z.string().optional(),
  deliveryDueDateTo: z.string().optional(),
  // 分類軸フィルタ（詳細フィルタパネル）
  priorityIn: z.array(z.enum(priorityValues)).optional(),
  poTypeIn: z.array(z.enum(poTypeValues)).optional(),
  orderDateFrom: z.string().optional(),
  orderDateTo: z.string().optional(),
  poSubtypeIn: z.array(z.enum(poSubtypeValues)).optional(),
  poModeIn: z.array(z.enum(poModeValues)).optional(),
  procurementCategoryIn: z.array(z.enum(procurementCategoryValues)).optional()
});
export type PoTableFilterSchema = z.infer<typeof PoTableFilterSchema>;